import { create } from 'zustand'
import { persist } from 'zustand/middleware'

const LOCAL_STORAGE_KEY = 'mfa_store'

interface MfaState {
  isMfaRequired: boolean
  isMfaSuccessful: boolean
  isSetupSuccessful: boolean

  setIsSetupSuccessful: (successful: boolean) => void
  setMfaRequired: (required: boolean) => void
  setMfaSuccessful: (successful: boolean) => void
  resetMfa: () => void
}

export const useMfaStore = create<MfaState>()(
  persist(
    set => ({
      isSetupSuccessful: false,
      isMfaRequired: false,
      isMfaSuccessful: false,

      setIsSetupSuccessful: successful => {
        set({ isSetupSuccessful: successful })
      },
      setMfaRequired: required => {
        set({ isMfaRequired: required })
      },
      setMfaSuccessful: successful => {
        set({ isMfaSuccessful: successful })
      },

      resetMfa: () => {
        set({
          isMfaRequired: false,
          isSetupSuccessful: false,
          isMfaSuccessful: false,
        })

        localStorage.removeItem(LOCAL_STORAGE_KEY)
      },
    }),
    {
      name: LOCAL_STORAGE_KEY,
    },
  ),
)
